import { Col, Row } from 'antd'
import React from 'react'
import useOneStationStore from '@/stores/oneStation'
import appConfig from '@/config'
import formatDate from '@/utils/formatDate'
import { useTranslation } from 'react-i18next'

interface StationValuesProps {
  name: string
  value: number | string // Adjust this if `value` can be another type
}
const StationValues: React.FC<StationValuesProps> = ({ name, value }) => {
  return (
    <div className='itemValue'>
      <div className='itemValue-label'>{name}</div>
      <div className='itemValue-value'>{value}</div>
    </div>
  )
}

const StationDetail: React.FC = () => {
  const { t } = useTranslation()
  const station = useOneStationStore(state => state.station)
  const testData = [
    { label: t('site.installedCapacity'), value: station.installed_capacity },
    { label: t('site.bess'), value: station.rated_capacity },
    { label: t('site.state'), value: station.agent },
    { label: t('site.nmi'), value: station.NMI },
    { label: t('site.address'), value: station.address },
    { label: t('site.postcode'), value: station.postal_code },
    { label: t('site.linkTime'), value: station.link_time ? formatDate(new Date(station.link_time)) : '' },
    // { label: "TimeZone", value: "UTC+08:00" },
  ]

  return (
    <div id='StationDetail'>
      <div className='StationDetail__header'>
        <Row gutter={20}>
          <Col span={4}>
            {station.station_image && station.station_image.length > 0 && (
              <img
                src={appConfig.staticFile + station.station_image[0]}
                style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '10px' }}
              />
            )}
          </Col>
          <Col span={18}>
            <div className='StationDetail__header-right'>
              <div className='StationDetail__header-title'>{station.station_name}</div>
              <div className='StationDetail__header-type'>
                {t('site.siteType')}: {station.station_type_name}
              </div>
              <div className='StationDetail__header-owener'>
                {t('site.owner')}: {station.create_name}
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className='StationDetail__content'>
        <Row gutter={[0, 40]}>
          {testData.map((v: any) => (
            <Col span={8} key={v.label}>
              <StationValues name={v.label} value={v.value} />
            </Col>
          ))}
        </Row>
      </div>
    </div>
  )
}

export default StationDetail
